import { JumpToAnchor } from './jumpToAnchor'

export class MeDownloadFilter {
  init () {
    const that = this
    const selectedDocuments = []
    const downloadCenterBlock = $('.download-center')
    const downloadCenterBlockFilter = $('.download-center__filter')
    const infoButtons = $('.download-center__info-button')
    const jumpToAnchor = new JumpToAnchor()

    infoButtons
      .on({
        click: function (event) {
          const infoButton = $(event.target)
          const form = infoButton.closest('.download-center').find('.tx-powermail').eq(0)

          jumpToAnchor.jumpToElement(form)

          infoButton
            .removeClass('download-center__info-button--show')
        }
      })

    if ((downloadCenterBlockFilter.length > 0)) {
      const filterCategory = downloadCenterBlockFilter.find('.download-center__filter-category')
      const filterText = downloadCenterBlockFilter.find('.download-center__filter-text')
      const filterCategories = JSON.parse(downloadCenterCategories)

      filterCategories.pop()

      if (filterCategories.length > 0) {
        filterCategories.forEach(function (category) {
          filterCategory
            .append(`<option value="${category.uid}">${category.title}</option>`)
        })
      }

      filterCategory.on('change', function () {
        that.processedFilter(filterCategory.val(), filterText.val())

        downloadCenterBlock.find('.form__checkbox-downloadcenter:checked').trigger('click')
      })

      filterText.on('keyup', function () {
        that.processedFilter(filterCategory.val(), filterText.val())

        downloadCenterBlock.find('.form__checkbox-downloadcenter:checked').trigger('click')
      })
    }

    downloadCenterBlock.find('.tx-powermail').addClass('tx-powermail--hide')
    downloadCenterBlock.find('.form__checkbox-downloadcenter').on('click', function () {
      if ($(this).prop('checked')) {
        if (selectedDocuments.indexOf($(this).val()) === -1) {
          selectedDocuments.push($(this).val())
        }
      } else {
        const documentSearchIndex = selectedDocuments.indexOf($(this).val())
        if (documentSearchIndex !== -1) {
          selectedDocuments.splice(documentSearchIndex, 1)
        }
      }

      $(this)
        .closest('.download-center__item')
        .toggleClass('download-center__item--selected', !!$(this).prop('checked'))

      $('.download-center__info-button')
        .toggleClass('download-center__info-button--show', !!(selectedDocuments.length > 0))

      if (selectedDocuments.length > 0) {
        downloadCenterBlock.find('.tx-powermail').removeClass('tx-powermail--hide')
        downloadCenterBlock.find('input[name="tx_powermail_pi1[field][dokumente]"]').val(selectedDocuments.join(', '))
      } else {
        downloadCenterBlock.find('.tx-powermail').addClass('tx-powermail--hide')
        downloadCenterBlock.find('input[name="tx_powermail_pi1[field][dokumente]"]').val('')
      }
    })
  }

  processedFilter (selectCategory, selectText) {
    const that = this
    const downloadListItems = $('.download-center .collapse-block__item')

    if (parseInt(selectCategory) === 0 && selectText === '') {
      downloadListItems.removeClass('download-center__item--hide')

      return true
    }

    downloadListItems.each(function () {
      if (that.isSearchedCategory($(this), selectCategory) && that.isSearchedText($(this), selectText)) {
        $(this).removeClass('download-center__item--hide')

        return true
      }

      $(this).addClass('download-center__item--hide')
    })
  }

  isSearchedCategory (item, selectCategory) {
    if (parseInt(selectCategory) === 0) {
      return true
    }

    if (typeof item.attr('data-download-category') !== 'undefined') {
      if (item.attr('data-download-category').search(`'${selectCategory}'`) !== -1) {
        return true
      }
    }

    return false
  }

  isSearchedText (item, selectText) {
    if (selectText === '') {
      return true
    }

    const title = item.find('.medownload__item--title-container').html()
    const description = item.find('.medownload__item--description-container').html()

    if (typeof title === 'string' && title.search(new RegExp(selectText, 'i')) !== -1) {
      return true
    }

    if (typeof description === 'string' && description.search(new RegExp(selectText, 'i')) !== -1) {
      return true
    }

    return false
  }
}

export default MeDownloadFilter
